
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.44 0.351562H0.960025C0.512025 0.351562 0.176025 0.687562 0.176025 1.13556V17.3196C0.176025 17.7676 0.512025 18.1036 0.960025 18.1036H19.44C19.888 18.1036 20.224 17.7676 20.224 17.3196V1.13556C20.224 0.687562 19.888 0.351562 19.44 0.351562ZM7.90403 6.06356C7.90403 6.95956 7.17603 7.63156 6.33603 7.63156C5.49603 7.63156 4.82403 6.95956 4.76803 6.06356C4.76803 5.16756 5.49603 4.49556 6.33603 4.49556C7.23203 4.49556 7.90403 5.22356 7.90403 6.06356ZM8.74403 13.1196L13.28 6.67956L17.872 15.3596H2.47203L6.39203 9.81556L8.74403 13.1196ZM1.74403 16.5356H18.656H18.712V1.86356H1.74403V16.5356Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Pic',
    }) as DefineComponent
    </script>
    